import React from "react";
import { Line } from "react-chartjs-2";

const ComplaintRateChart = ({ labels = [], datas = [] }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: "อัตราการแจ้งเรื่องร้องเรียนประจำปี 2024",
        data: datas,
        fill: true,
        backgroundColor: "rgba(99, 102, 241, 0.2)", // Tailwind's indigo-500 with opacity
        borderColor: "#6366F1", // Tailwind's indigo-500
        pointBackgroundColor: "#6366F1",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#6366F1",
        tension: 0.4, // Smooth curve
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: "#fff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#6366F1",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 2,
        },
      },
    },
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-4">
      <h2 className="text-2xl font-semibold mb-4">
        อัตราการแจ้งเรื่องร้องเรียนประจำปี 2024
      </h2>
      <Line data={data} options={options} />
    </div>
  );
};

export default ComplaintRateChart;
